import { Routes } from "@angular/router";
import { DashboardComponent } from "app/dashboard/component/dashboard/dashboard.component";
import { LayoutComponent } from "app/shared/components/layout/layout.component";
import { MsalGuard } from '@azure/msal-angular';

export const DASHBOARD_ROUTES: Routes = [
    { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    {
		path: 'dashboard',
		component: LayoutComponent,
		canActivate: [MsalGuard],
		children: [
			{ path: '', component: DashboardComponent }
		]
	}
];
